import { Injectable } from '@angular/core';
import { PartnerInfo, SEJFY_PARTNER } from '../consts';
import { resolveCountryFromTimezone } from '../utils';

@Injectable({ providedIn: 'root' })
export class PartnersService {
  readonly sejfy: PartnerInfo = SEJFY_PARTNER;
  readonly list: ReadonlyArray<PartnerInfo> = [SEJFY_PARTNER];

  byId(id: string): PartnerInfo | undefined {
    return this.list.find((partner: PartnerInfo): boolean => partner.id === id);
  }

  open(partner: PartnerInfo = this.sejfy): void {
    window.open(this.buildUrl(partner), '_blank');
  }

  private buildUrl(partner: PartnerInfo): string {
    const base: string = this.resolveUrl(partner);
    const entries: ReadonlyArray<[string, string]> = Object.entries(partner.urlParams);
    if (entries.length === 0) {
      return base;
    }
    const query: string = entries
      .map(([key, value]: [string, string]): string => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    const separator: string = base.includes('?') ? '&' : '?';
    return `${base}${separator}${query}`;
  }

  private resolveUrl(partner: PartnerInfo): string {
    const country: string | null = resolveCountryFromTimezone();
    if (country && partner.urlByCountry[country]) {
      return partner.urlByCountry[country];
    }
    return partner.url;
  }
}
